import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { OrderDetails } from '../../../core/model';
import { Occ } from '../../../core/occ/occ-models';
import { ConverterService } from '../../../core/util/converter.service';
import { ORDER_DETAILS_NORMALIZER } from './converters';

@Injectable({
  providedIn: 'root',
})
export class OrderDetailsConnector {
  constructor(
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService
  ) {}

  getOrderDetails(userId: string, sapOrderNumber: string, mergeMode: boolean = false): Observable<OrderDetails> {
    const url = this.occEndpointsService.buildUrl('orderDetails', {
      urlParams: { userId, orderCode: sapOrderNumber },
      queryParams: { mergeMode: mergeMode },
    });
    return this.httpClient.get<Occ.OrderDetailsOrder>(url).pipe(this.converterService.pipeable(ORDER_DETAILS_NORMALIZER));
  }
}
